import styled from 'styled-components';

const StyledContainer = styled.div`
	position: absolute;
	top: 495px;
	left: 30px;
	display: flex;
	flex-direction: column;
	gap: 10px;
	align-items: flex-start;
`;

const StyledBanContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	height: 30px;
	padding: 0 10px;
	background-color: #c71e1e;
	border-radius: 10px;

	p {
		font-family: 'GT Walsheim Pro';
		font-style: normal;
		font-weight: 700;
		font-size: 16px;
		line-height: normal;
		color: #ffffff;
		user-select: none;
		pointer-events: none;
	}

	img {
		flex-shrink: 0;
		width: 16px;
		height: 16px;
		user-select: none;
		pointer-events: none;
	}

	transition:
		opacity 0.5s ease,
		transform 0.5s ease;
	transform: translateX(-100%);
	opacity: 0;

	&.ban-enter {
		opacity: 0;
		transform: translateX(-100%);
	}

	&.ban-enter-active,
	&.ban-enter-done,
	&.ban-exit {
		opacity: 1;
		transform: translateX(0);
	}

	&.ban-exit-active {
		transform: translateX(-100%);
		opacity: 0;
	}
`;

export { StyledBanContainer, StyledContainer };
